/**
 * @author: leroy
 * @date: 2021/11/3 11:22
 * @description：user
 */
import { makeAutoObservable, runInAction } from 'mobx';
import { getExamUserInfo } from '@/store/services/user';
import Cookies from 'js-cookie';

export class UserStore {
  userInfo: API.User['info'];
  auth: string | undefined = '';
  user_id: number | string | undefined;
  resumes: API.User['resumeList'];
  phone: string = '';
  collegeList: API.CollegeList | undefined;
  majorList: API.MajorList | undefined;
  anidInfo: { area_code; name; phone; platform } | undefined;
  // 登录弹窗
  loginModelShow = false;
  // 小名片弹出昂
  perfectModelShow = false;
  //核验弹窗
  confirmModalShow = false;

  setConfirmModalShow = (flag: boolean) => {
    this.confirmModalShow = flag;
  };
  // 登录弹窗
  handleLoginModel = (flag: boolean) => {
    this.loginModelShow = flag;
  };

  saveUser = ({ auth, info, user_id, phone }: API.User) => {
    this.auth = auth;
    this.userInfo = info;
    this.user_id = user_id;
    this.phone = phone;

    Cookies.set('exam_auth', auth, {
      path: '/',
      domain: '.haitou.cc',
      expires: 30,
    });
  };

  setData = (key: keyof UserStore, value) => {
    //@ts-ignore
    this[key] = value;
  };

  loginout = () => {
    this.auth = undefined;
    this.user_id = undefined;
    this.phone = '';
  };

  getExamUserInfo = async () => {
    try {
      const data = await getExamUserInfo();
      if (data.status === 'success') {
        runInAction(() => {
          this.phone = data.data.phone;
          this.user_id = data.data.id;
        });
        return data;
      }
      Cookies.remove('exam_auth', { domain: '.haitou.cc' });
      return undefined;
    } catch (error) {
      console.log('getUserInfo', error);
      return undefined;
    }
  };

  constructor() {
    makeAutoObservable(this);
  }
}

export default UserStore;
